// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    TOOLTIP_MAIN_CONTAINER: 'tooltip_main_container',
};
